import React, {FC} from 'react';
import s from './CardItem.module.css';

interface Item {
    text: string;
    isActive: boolean;
    tag: string;
    color?: string;
    icon?: string;
}

interface CardItemProps {
    item: Item;
    onClick: (item: Item) => void;
    size?: 'small'
}

const CardItem: FC<CardItemProps> = ({ item, onClick, size }) => {
    return (
        <div className={s.background}>
        <div
            style={{background:item.isActive?item.color:'white'}}
            className={`${s.container} 
                            ${item.isActive ? s.active : ''} 
                            ${size === 'small' ? s.small : ''}`}
            onClick={() => onClick(item)}
        >
            {item.text}
        </div>
        </div>
    );
};

export default CardItem;
